import { defineStore } from 'pinia';
import { request } from '@/utils/api';

// Number of unread-schedule issues still open, for the badge on the developer menu.
export const useScheduleProblemsStore = defineStore('scheduleProblems', {
  state: () => ({ open: 0 }),
  actions: {
    async refresh() {
      try {
        const result = await request('GET', '/admin/schedule-problems/count');
        this.open = Number(result?.open) || 0;
      } catch (e) {
        // the badge is a convenience: never show an error for it
      }
    },
  },
});
